import React, { useCallback, useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import CustomMultiSelect from '../../shared/CustomMultiSelect';
import CustomButton from '../../shared/CustomButton';
import CustomDropDown from '../../shared/CustomDropDown';
import { showProgress } from '../../../redux/actions/DealershipActions';
import Service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast } from '../../utils/Utils';
import { dealershipSortOptions } from '../constants';

const useStyles = makeStyles({
  detailsContainer: {
    padding: '8px 0px 0px 6px',
    background: 'rgba(242, 244, 247, 1)',
  },
  dropdownContainer: {
    marginRight: '20px',
  },
});

const DealershipFilter = ({
  filters,
  filterObjectInitial,
  handleDealerships,
  departmentRoleIds,
  handleSort,
  sortType,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [filterObj, setFilterObj] = useState({ ...filterObjectInitial, departmentRoleIds });

  useEffect(() => {
    getDealerships();
  }, []);

  const handleFilterUpdate = useCallback((selectedValues, label) => {
    setFilterObj((prevFilter) => ({
      ...prevFilter,
      [label]: selectedValues,
    }));
  }, []);
  const getDealerships = useCallback(async () => {
    dispatch(showProgress(true));
    try {
      const response = await Service.post(apiEndpoints.LB_DEALER_FILTER, { filters: filterObj });
      handleDealerships(response);
    } catch (err) {
      ErrorToast(err);
    }
    dispatch(showProgress(false));
  }, [filterObj]);

  const resetFilters = useCallback(() => {
    setFilterObj({ ...filterObjectInitial, departmentRoleIds });
  }, [filterObjectInitial]);

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={classes.detailsContainer}
    >
      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.detailsContainer}
        >
          <Grid item>
            <CustomMultiSelect
              width="150px"
              height="32px"
              label="Source"
              name="source"
              list={filters?.source}
              handleFilterChange={handleFilterUpdate}
              selectedValue={filterObj.source}
            />
          </Grid>
          <Grid item>
            <CustomMultiSelect
              width="150px"
              height="32px"
              label="Plan"
              name="plans"
              list={filters?.plans}
              handleFilterChange={handleFilterUpdate}
              selectedValue={filterObj.plans}
            />
          </Grid>
          <Grid item>
            <CustomMultiSelect
              width="150px"
              height="32px"
              label="Parent"
              name="dealerGroupIds"
              list={filters?.dealerGroup}
              handleFilterChange={handleFilterUpdate}
              selectedValue={filterObj.dealerGroupIds}
            />
          </Grid>
          <Grid item>
            <CustomMultiSelect
              width="150px"
              height="32px"
              label="Sales Pipeline Status"
              name="salesPipelineStatus"
              list={filters?.salesPipelineStatus}
              handleFilterChange={handleFilterUpdate}
              selectedValue={filterObj.salesPipelineStatus}
            />
          </Grid>
          <Grid item style={{ marginRight: '8px' }}>
            <CustomButton size="small" label="Apply" type="primary" onClick={getDealerships} />
          </Grid>
          <Grid item>
            <CustomButton size="small" label="Reset" type="secondary" onClick={resetFilters} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item className={classes.dropdownContainer}>
        <CustomDropDown
          name="dealershipSort"
          width="121px"
          height="32px"
          list={dealershipSortOptions}
          handleChange={handleSort}
          value={sortType}
        />
      </Grid>
    </Grid>
  );
};

export default DealershipFilter;
